import { axios } from '@/utils/request'

/**
 * 查询特色癫痫门诊
 *
 * @author liwei
 * @date 2022-06-19 15:11:33
 */
export function contentDetailPage (parameter) {
  return axios({
    url: '/contentDetail/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 特色癫痫门诊列表
 *
 * @author liwei
 * @date 2022-06-19 15:11:33
 */
export function contentDetailList (parameter) {
  return axios({
    url: '/contentDetail/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加特色癫痫门诊
 *
 * @author liwei
 * @date 2022-06-19 15:11:33
 */
export function contentDetailAdd (parameter) {
  return axios({
    url: '/contentDetail/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑特色癫痫门诊
 *
 * @author liwei
 * @date 2022-06-19 15:11:33
 */
export function contentDetailEdit (parameter) {
  return axios({
    url: '/contentDetail/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除特色癫痫门诊
 *
 * @author liwei
 * @date 2022-06-19 15:11:33
 */
export function contentDetailDelete (parameter) {
  return axios({
    url: '/contentDetail/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出特色癫痫门诊
 *
 * @author liwei
 * @date 2022-06-19 15:11:33
 */
export function contentDetailExport (parameter) {
  return axios({
    url: '/contentDetail/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
